<template>
  <button
    :id="id"
    :disabled="disabled || loading"
    @click="$emit('click')"
    :class="[
      'button',
      {
        'button_full-width': fullWidth,
        button_disabled: disabled,
        'button_disabled-color': color === 'disabled',
        button_primary: color === 'primary',
        button_secondary: color === 'secondary',
        button_link: color === 'link',
        'button_link-secondary': color === 'link-secondary',
        'button_secondary-fill': color === 'secondary-fill',
        button_danger: color === 'danger',
        button_warning: color === 'warning',
      },
    ]"
  >
    <slot v-if="!loading"> </slot>
    <div v-else class="button-loader">
      <div class="dot dot-1"></div>
      <div class="dot dot-2"></div>
      <div class="dot dot-3"></div>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    fullWidth: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    id: { type: [String, Number] },
    color: {
      type: String,
      require: false,
      default: "primary",
    },
  },
};
</script>

<style scoped>
.button {
  min-width: 93px;
  min-height: 36px;
  padding: 10px 24px;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
  opacity: 1;
  transition: background-color 0.15s ease-out, border 0.15s ease-out, color 0.15s ease-out, border 0.15s ease-out,
    opacity 0.15s ease-out;
  border: none;
}

.button:hover {
  opacity: 0.75;
}

.button_full-width {
  width: 100%;
}

.button_primary {
  background: var(--primary-color);
  color: var(--white-color);
  border: 1px solid var(--primary-color);
}
.button_primary:hover {
  opacity: 1;
  border: 1px solid var(--primary-hover-color);
  background: var(--primary-hover-color);
}
.button_primary:focus,
.button_primary:active {
  opacity: 1;
  border: 1px solid var(--primary-focused-color);
  background: var(--primary-focused-color);
}
.button_secondary {
  background: var(--white-color);
  color: var(--secondary-color);
  border: 1px solid var(--secondary-color);
}
.button_secondary:hover {
  opacity: 1;
  color: var(--secondary-hover-color);
  border: 1px solid var(--secondary-hover-color);
}
.button_secondary:focus,
.button_secondary:active {
  color: var(--secondary-focused-color);
  border: 1px solid var(--secondary-focused-color);
}
.button_link {
  background: transparent;
  color: var(--primary-color);
  border: 1px solid transparent;
}
.button_link:hover {
  opacity: 1;
  background: var(--primary-hover-color);
  color: var(--white-color);
  border: 1px solid var(--primary-hover-color);
}
.button_link:focus,
.button_link:active {
  opacity: 1;
  color: var(--primary-focused-color);
}
.button_link-secondary {
  background: transparent;
  color: var(--secondary-color);
  border: none;
}
.button_link-secondary:hover {
  opacity: 1;
  color: var(--secondary-hover-color);
}
.button_secondary-fill {
  background: var(--secondary-color);
  color: var(--white-color);
  border: var(--secondary-color);
}
.button_secondary-fill:hover {
  opacity: 1;
  background: var(--secondary-hover-color);
  border: var(--secondary-hover-color);
}
.button_secondary-fill:focus,
.button_secondary-fill:active {
  background: var(--secondary-focused-color);
  border: var(--secondary-focused-color);
}
.button_danger {
  background: var(--error-color);
  color: var(--white-color);
  border: none;
}
.button_warning {
  background: var(--warning-color);
  color: var(--white-color);
  border: none;
}

.button_disabled,
.button_disabled-color {
  background-color: var(--border-color);
  border: 1px solid var(--border-color);
  cursor: default;
}
.button_disabled:hover,
.button_disabled-color:hover {
  background-color: var(--border-color);
  border: 1px solid var(--border-color);
  cursor: default;
  opacity: 1;
}
.button-loader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 20px;
  height: 4px;
  margin: 0 auto;
}

.dot {
  min-width: 4px;
  min-height: 4px;
  border-radius: 50%;
  background-color: var(--grey-3-color);
  margin: 0;
  animation: dotAnimation 1.5s infinite ease-in-out;
}

.dot-1 {
  animation-delay: 0s;
}

.dot-2 {
  animation-delay: 0.5s;
}

.dot-3 {
  animation-delay: 1s;
}

@keyframes dotAnimation {
  0% {
    background-color: var(--primary-color); /* начальный цвет */
  }
  50% {
    background-color: var(--grey-color); /* промежуточный цвет */
  }
  100% {
    background-color: var(--grey-3-color); /* конечный цвет */
  }
}
</style>
